'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */
exports.default = window.__wxjs_environment === 'miniprogram' || /miniprogram/i.test(navigator.userAgent);
/* eslint-enable */


//////////////////
// WEBPACK FOOTER
// ./~/@guazi-fe/components/build/client/utils/isMiNiProgram.js
// module id = 1454
// module chunks = 1